export default {
  setVeiculos(state, payload) {
    state.veiculos = payload
  },

  setSelectedVeiculo(state, payload) {
    state.selectedVeiculo = payload
  }
}
